module.exports = __webpack_public_path__ + "img/LoadingOpening.bcaf7b56.svg";